import React, { Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
const App = React.lazy(() => import('./App'));
// import App from './App';




const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const DelayedFallback = () => {
  const [show, setShow] = useState(false)
  useEffect(() => {
    let timeout = setTimeout(() => setShow(true), 600)
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <>
      {show && <div className="loading">Loading @...</div>}
    </>
  )
}
export default DelayedFallback
root.render(
  <Suspense fallback={<DelayedFallback />}>
    <App />
  </Suspense>);


//to do add routing!@
// import {
//   BrowserRouter,
//   Link,
//   Route,
//   Routes,
// } from "react-router-dom";
// function Home() {
//   return (
//     <>
//       <h1>Welcome!</h1>
//       <p>
//         Check out the <Link to="/blog">blog</Link> or the{" "}
//         <Link to="users">users</Link> section
//       </p>
//     </>
//   );
// }

// function BlogApp() {
//   return (
//     <Routes>
//       <Route index element={<h1>Blog Index</h1>} />
//       <Route path="posts" element={<h1>Blog Posts</h1>} />
//     </Routes>
//   );
// }

// function UserApp() {
//   return (
//     <Routes>
//       <Route index element={<h1>Users Index</h1>} />
//     </Routes>
//   );
// }